export default __webpack_public_path__ + "static/media/EVENT212AARRAY.adc4db2c.png";